import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";
import { CancelSubscription } from "../cancel-subscription.model";

@Injectable()
export class CancelSubscriptionService {
  constructor(private http: CHttp) {}

  public cancelSubscription(data: CancelSubscription) {
    return this.http.post(
      config.api_url + "members/subscriptions/android/cancel",
      data
    );
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/cancel-subscription/services/cancel-subscription.service.ts